import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { downloadBlob } from '@/_shared/helpers/download';
import { GenericApiError } from '@/_shared/types/apiError';
import { API_GET_DOWNLOAD_PAYMENT_RECEIPT, KEY_GET_DOWNLOAD_PAYMENT_RECEIPT } from '../constants';
import { MOCK_RESPONSE_GET_DOWNLOAD_PAYMENT_RECEIPT } from '../mocks';

export type CallParamsGetDownloadPaymentReceipt = {
  paymentId: string;
  fileName?: string;
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponseGetDownloadPaymentReceipt = Blob;

type CallErrorGetDownloadPaymentReceipt = GenericApiError;

type CallSelectorsGetDownloadPaymentReceipt = unknown;

let fileName: string | undefined;

export const getDownloadPaymentReceiptCall = createGeneralCall<
  CallParamsGetDownloadPaymentReceipt,
  CallResponseGetDownloadPaymentReceipt,
  CallErrorGetDownloadPaymentReceipt,
  CallSelectorsGetDownloadPaymentReceipt
>({
  id: KEY_GET_DOWNLOAD_PAYMENT_RECEIPT,
  url:
    ({ payload: { paymentId, fileName: givenFileName } }) =>
    () => {
      fileName = givenFileName || undefined;
      return API_GET_DOWNLOAD_PAYMENT_RECEIPT(paymentId);
    },
  method: 'get',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_DOWNLOAD_PAYMENT_RECEIPT : undefined,
  responseExtractor: 'blob',
  responseMapper: ({ response: blob }) => {
    downloadBlob(blob, fileName);
  },
});
